import { defineMessages } from 'react-intl';

export default defineMessages({
  showAllCommitsButton: {
    id: 'frontbucket.commitList.filters.showAll',
    description:
      'Label for a link to show all commits for a repository across all branches',
    defaultMessage: 'Show all',
  },
  searchPlaceholder: {
    id: 'frontbucket.commitList.filters.searchPlaceholder',
    description: 'Placeholder for commit list search filter input',
    defaultMessage: 'Search commits',
  },
});
